import {disableSubmitButton} from "../../public/bundles/w3comhulk/ajax";
import Dropzone from "dropzone";
import {appRequest} from "./utils_request";
import {vehicleSaleAssignmentAssign} from "./display_liste_vehicule_vente";
Dropzone.autoDiscover = false;

let param = {};

export const init = () => {
    $(document).ready(() => {
        initDropzone();
    });

    return {setParams};
}

const setParams = (filename, basename) => {
    param.filename = filename;
    param.basename = basename;
    param.url_treatment_precheck = urls.importCheck.replace('toRpFilename', filename);
    param.url_integration = urls.importCreate.replace('toRpFilename', filename);
    param.url_regle_import = urls.importRules.replace('toRpFilename', filename);
    param.url_logiwin = urls.importLogiwin.replace('toRpFilename', filename);
    //param.url_display = urlDisplay;
}

const initDropzone = () => {
    const inputFileName = document.getElementById('vehicle_import_fileName');

    if (!inputFileName) return;

    if (document.getElementById('form_uploaded_file') === null) return;

    Dropzone.autoDiscover = false;
    let importDropzone = new Dropzone('#form_uploaded_file', {
        url: urls.uploadExcel,
        init: function () {
            this.on("addedfile", function () {
                if (this.files[1] != null) {
                    this.removeFile(this.files[0]);
                }
            });
        },
        renameFile: function (file) {
            //inputFileName.value = Date.now() + file.name;
            var now = new Date();
            inputFileName.value = now.getFullYear().toString() +
                (now.getMonth() < 9 ? '0' : '') + (now.getMonth() + 1).toString() +
                (now.getDate() < 10 ? '0' : '') + now.getDate().toString() +
                (now.getHours() < 10 ? '0' : '') + now.getHours().toString() +
                (now.getMinutes() < 10 ? '0' : '') + now.getMinutes().toString() +
                (now.getSeconds() < 10 ? '0' : '') + now.getSeconds().toString() + '_' + file.name;
            //return Date.now() + file.name;
            return inputFileName.value;
        },
        addRemoveLinks: true,
        // acceptedFiles: 'text/csv,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        acceptedFiles: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        dictRemoveFile: 'Supprimer',
        dictCancelUpload: 'Annuler',
        dictMaxFilesExceeded: 'Vous êtes limité à un fichier.'
    });

    importDropzone.on('removedfile', (file) => {
        inputFileName.value = null;
        $.post(urls.deleteExcel, {'filename': file.upload.filename});
    });
}

global.launchCheckTreatment = function () {
    $.get(param.url_treatment_precheck, function (rep) {
        if (rep.hasOwnProperty('status') && rep.status == 'success') {
            $('#import_precheck').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-check-circle').addClass('text-success');
            $('#messagePrecheck').html('Tous les véhicules ont été vérifiés');

            // Launch next step
            $('#bloc_integration').removeClass('d-none');
            launchIntegrationTreatment();

        } else {
            $('#import_precheck').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-exclamation-triangle').addClass('text-danger');
            $('#messagePrecheck').html(rep.res.vehiclesOk + ' véhicule(s) intégrable(s)<br /><br />' + rep.data.join('<br />'));
            $('#boutonPrecheck').removeClass('d-none')
        }
    })
};

global.abortTreatment = function (url, url_home) {
    $.get(url, function (rep) {
        if (rep.hasOwnProperty('status') && rep.status == 'success') {
            window.location = url_home;
        }
    })
};

global.launchIntegrationTreatment = function (obj) {

    disableSubmitButton(obj);
    $('#boutonPrecheck a').addClass('d-none');

    $.get(param.url_integration, function (rep) {

        if (rep.hasOwnProperty('status') && rep.status === 'success') {
            $('#import_integration').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-check-circle').addClass('text-success');
            $('#messageIntegration').html('Tous les véhicules ont été intégrés');
            // Launch next step
            $('#bloc_regle_import').removeClass('d-none');
            launchRegleImportTreatment();
            if (obj !== undefined){
                obj.style.display = 'none';
            }
        } else {
            $('#bloc_integration').removeClass('d-none');
            $('#import_integration').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-exclamation-triangle').addClass('text-danger');
            $('#messageIntegration').html(rep.data.join('<br />'));
            if (obj !== undefined){
                obj.style.display = 'none';
            }
            //$('#boutonPrecheck').removeClass('d-none')
        }
    })
};

global.launchRegleImportTreatment = function () {
    $.get(param.url_regle_import, function (rep) {
        if (rep.hasOwnProperty('status') && rep.status === 'success') {
            $('#import_regle_import').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-check-circle').addClass('text-success');
            $('#messageRegleImport').html(rep.data);
            // Launch next step
            // if (rep.to_logiwin !== 0) {
            //     $('#bloc_logiwin').find('h5').text('Lancement de logiwin sur les ' + rep.to_logiwin + ' véhicules concernés.');
            //     $('#bloc_logiwin').removeClass('d-none');
            //     callLogiwin(param.url_logiwin, {'mode': 'filename', 'token': param.basename});
            // } else {
            //     window.location = '/display/VHStock?U_W3C_INTF=' + param.basename;
                window.location = '/display/VHStock?NomFichierImport=' + param.basename;
            // }
        } else {
            $('#import_regle_import').removeClass('fa-circle-notch').removeClass('fa-spin').addClass('fa-exclamation-triangle').addClass('text-danger');
            $('#messageRegleImport').html(rep.data.join('<br />'));
        }
    })
};

global.openBP = function () {
    const CardCode = $('#vehicle_import_cardCode').val();
    if (CardCode != undefined) {
        sap.sbo.webbridge.openForm('OCRD', CardCode);
    }
};

export const vehicleImportChangeSeller = (data, callFunction) => {
    let sellerId = $('#seller-select').val();

    let rows = JSON.parse(data);

    callFunction.addMessage('Modification des vendeurs...');
    callFunction.startLoading();

    appRequest(urls.changeSellerVhImportGo, {
        'sellerId': sellerId,
        'vhImportIds': rows.map(obj => obj.Code)
    })
    .then((resp) => {
        callFunction.stopLoading();
        callFunction.addMessage(resp.message);
        callFunction.addReloadButton();
    });
};


// WEBPACK FOOTER //
// ./assets/js/import_vehicle.js